import React,{Component} from 'react';


class CardData extends Component{
    state = {
        check:5
    }
    test = () => {
        this.props.onCardData(this.state.check)
    }
    render(){
        return(
            <>
                {/* <p>Im from Card Data</p> */}
                {/* <button className="btn btn-sm btn-primary" onClick={this.test}>Card Box</button> */}
            </>
        )
    }
}

export default CardData;
